import { Injectable } from '@angular/core';
import { GenericService } from './generic.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificacaoAgendadaService extends GenericService {

  constructor(http: HttpClient) {
      super(http, 'enviar-notificacao');
  }

  insert(params = null, app = null): Observable<any> {
    let url = `${this.url_base}/${this.prefixo}/insert`;
    return this.http.post(url, params);
  }
}
